var PRODUCT_TYPE = {
    BUSINESS_RETAIL_CARD: "BUSINESS_RETAIL_CARD",
    DUAL_CARD: "DUAL_CARD",
    LIMITED_USE_DUAL_CARD: "LIMITED_USE_DUAL_CARD",
    PRIVATE_LABEL: "PRIVATE_LABEL",
    INSTALLMENT_LOAN: "INSTALLMENT_LOAN",
    INSTALLMENT_LOAN_PAY_IN_FOUR: "INSTALLMENT_LOAN_PAY_IN_FOUR",
    INSTALLMENT_LOAN_MONTHLY: "INSTALLMENT_LOAN_MONTHLY",
    INSTALLMENT_LOAN_SECURED: "INSTALLMENT_LOAN_SECURED",
};
export var LOAN_TYPES = [
    PRODUCT_TYPE.INSTALLMENT_LOAN,
    PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED,
    PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY,
    PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR,
];
export default PRODUCT_TYPE;
//# sourceMappingURL=productType.js.map